/**
 * Reading phases.
 */
export var GedcomReadingPhase;
(function (GedcomReadingPhase) {
    GedcomReadingPhase[GedcomReadingPhase["Decoding"] = 0] = "Decoding";
    GedcomReadingPhase[GedcomReadingPhase["TokenizationAndStructuring"] = 1] = "TokenizationAndStructuring";
    GedcomReadingPhase[GedcomReadingPhase["Indexing"] = 2] = "Indexing";
    GedcomReadingPhase[GedcomReadingPhase["Freezing"] = 3] = "Freezing";
})(GedcomReadingPhase || (GedcomReadingPhase = {}));
//# sourceMappingURL=GedcomReadingPhase.js.map